import * as Api from "./api";
import * as utils from "./utils";
import Handlebars from 'handlebars';
import '../helpers/obj';
import {loadNotifications} from '../../views/widgets/notifications/js/loadWg';
import {loadRecommendationsModal} from '../../views/widgets/recommendationsModal/js/loadWg';
import * as dataLayer from './dataLayer';
import {getPriceOrFree} from "./checkout";
import {updatePomotional} from "../../views/blocks/promotionalList/js/promotionalList";

const CLS_INVALID = 'invalid';
const CLS_HIDE = 'd-none';
const CLS_INVISIBLE = 'invisible';
const CLS_ACTIVE = 'is-active';

// TODO:
// Move remove/update item to here

/**
 * Apply promo code API
 * @param {JQuery element} $el - Parent element
 * @param {Object} couponObj - Contain (api, value)
 */
export function applyPromoCode($el, couponObj) {
	let $discountLabel = $el.find(`.discounttotal-label`) || $(document).find(`.discounttotal-label`);
	let $discountValue = $el.find(`.discounttotal-value`) || $(document).find(`.discounttotal-value`);
	let $errorMessage = $el.find('#couponCodeMessage');
	let $couponShipping = $el.find('.coupon-shipping-js') || $(document).find('.coupon-shipping-js');
	// let $couponCode = $el.find('#couponCode') || $('#couponCode');
	let $deleteCouponCodeForm = $el.find('#deleteCouponCodeForm') || $('#deleteCouponCodeForm');
	let param = {
		'couponValue': couponObj.value,
	};

	// toggle spinners
	$('.loading-spinner').addClass('is-active');

	Api.callApi(couponObj.api, param).then((data) => {
		if (data.result == 'SUCCESS') {
			let res = data.response;
			// get values
			let taxes = res.totaltaxes || 0;
			let subtotal = res.subtotal || 0;
			let total = res.total || 0;
			let cartCount = res.lineitemscount || 0;
			let discounttotal = res.discounttotal || '0';
			let shippingTotal = res.shippingTotal || 0;
			let orderCouponCode = res.orderCouponCode || '';
			let shippingCouponCode = res.shippingCouponCode || '';
			let totalWithoutShipping = res.totalWithoutShipping || '';

			// $couponCode.val('');

			// Update total price method
			updateTotalPriceShippingMethod(res.shippingMethods || null);

			// update markup
			$el.find('.subtotal-value').text('$' + parseFloat(subtotal).toFixed(2));
			$el.find('.tax-value').text('$' + parseFloat(taxes).toFixed(2));
			$el.find('.total-value').text('$' + parseFloat(total).toFixed(2));
			$el.find('.total-without-shipping').text('$' + parseFloat(totalWithoutShipping).toFixed(2));
			$el.find('.shipping-value').text('$' + parseFloat(shippingTotal).toFixed(2));

			// handle discount
			if (parseFloat(discounttotal || 0) && orderCouponCode) {
				$discountValue.text('-$' + parseFloat(discounttotal).toFixed(2)).removeClass(CLS_HIDE);
				$discountLabel.removeClass(CLS_HIDE);
				$discountLabel.find('.coupon-text').html(couponTag(orderCouponCode)).removeClass(CLS_HIDE);
			} else {
				$discountValue.addClass(CLS_HIDE);
				$discountLabel.addClass(CLS_HIDE);
				$discountLabel.find('.coupon-text').addClass(CLS_HIDE);
			}

			// Handle shipping
			if (shippingCouponCode) {
				$couponShipping.find('.coupon-text').html(couponTag(shippingCouponCode)).removeClass(CLS_HIDE);
			} else {
				$couponShipping.find('.coupon-text').html('').addClass(CLS_HIDE);
			}

			if ($(document).find('.siteHeader-cartCount').length > 0) {
				$(document).find('.siteHeader-cartCount').text(cartCount);
				$(document).find('.siteHeader-subTotal').text(' = $' + parseFloat(res.subtotal).toFixed(2));
			}

			$errorMessage.removeClass('is-active');
			$el.find('#couponCode').removeClass(CLS_INVALID);
			$('.loading-spinner').removeClass('is-active');
			$el.find('#couponCode').val('');

			updatePomotional(res.freeOrDiscountedPromotionalItems, res.lineItemPrices);
		} else {
			// show error div
			$errorMessage.addClass('is-active').html(data.message);
			$el.find('#couponCode').addClass(CLS_INVALID);
			$('.loading-spinner').removeClass('is-active');
		}
	});
}

export function couponTag(code) {
	return [
		$(`<span>"${code}"</span>`),
		$(`<div class="miniCart-removeIcon delete-coupon-btn" discount-code="${code}"><i class="icon-delete"></i></div>`),
	];
}

export function updateTotalPriceShippingMethod(shippingMethods = []) {
	shippingMethods && shippingMethods.forEach(method => {
		const price = method.Price.Amount;
		const {BasePrice, HeavyItemPrice, Id} = method;
		const isFree = parseFloat(price) == 0;
		// Rural off.
		$(`[shipping-method-id="${Id}"] .totalPrice:not(.heavy-item)`).text(`
			${isFree ? 'FREE' : BasePrice}
		`);

		$(`[shipping-method-id="${Id}"] .totalPrice.heavy-item`).text(`
			${isFree ? 'FREE' : HeavyItemPrice}
		`);
		// Rural on.
		$(`[shipping-method-id="${Id}"] .heavy-item-price:not(.has-from)`).text(`
			${isFree ? 'FREE' : HeavyItemPrice}
		`);

		$(`[shipping-method-id="${Id}"] .normal-item-price:not('.has-from')`).text(`
			${isFree ? 'FREE' : BasePrice}
		`);

		$(`[shipping-method-id="${Id}"] .heavy-item-price.has-from`).text(`
			${isFree ? 'FREE' : 'From ' + HeavyItemPrice}
		`);

		$(`[shipping-method-id="${Id}"] .normal-item-price.has-from`).text(`
			${isFree ? 'FREE' : 'From ' + BasePrice}
		`);

	});
}

export function handleDiscountView(discounttotal, couponCodes) {
	let $discountLabel = $(document).find(`.discounttotal-label`);
	let $discountValue = $(document).find(`.discounttotal-value`);

	if (discounttotal !== '0' && couponCodes.length > 0) {
		$discountValue.text('-$' + parseFloat(discounttotal).toFixed(2)).removeClass(CLS_HIDE);
		$discountLabel.removeClass(CLS_HIDE);
	} else {
		$discountValue.text('').addClass(CLS_HIDE);
		$discountLabel.addClass(CLS_HIDE);
	}
}

export function handleCouponShipping(shippingCouponCode) {
	const $couponShipping = $('.coupon-shipping-js');
	if (shippingCouponCode) {
		$couponShipping.find('.coupon-text').text(`"${shippingCouponCode}"`).removeClass(CLS_HIDE);
	} else {
		$couponShipping.find('.coupon-text').text('').addClass(CLS_HIDE);
	}
}

export function addToCart(prop, succesCB, failCB) {
	if (!prop.endpoint) {
		if (failCB) failCB({
			message: `Can't find Endpoint. Returned early.`,
		});
		return;
	}


	let param = {};

	if(prop.isBundles){
		param = {
			'items': prop.items,
		};
	} else {
		param = {
			'code': prop.code,
			'quantity': prop.quantity,
		};
		if (prop.customAmount !== '') param.customAmount = prop.customAmount;
		if (prop.settingAmount !== '') param.settingAmount = prop.settingAmount;
	}

	let $endpointDef = $('.endpoints-definition');

	Api.callApi(prop.endpoint, param).then((data) => {
		if (data.result == 'SUCCESS') {
			// update cart count and total in the siteHeader
			let $cartCount = $(document).find('.siteHeader-cart .siteHeader-cartCount');

			let productObj = {
				code: prop.code,
				quantity: prop.quantity,
				size: prop.size || '',
				items: prop.items,
			};

			dataLayer.pushAddToCart(productObj, prop.datalayerDataSource);

			let res = data.response;

			if ($cartCount.length > 0) {
				$cartCount.text(res.cartCount);

				if (res.cartCount > 0) {
					$cartCount.removeClass(CLS_INVISIBLE);
				} else {
					$cartCount.addClass(CLS_INVISIBLE);
				}

				$(document).find('.siteHeader-subTotal').text(' = $' + parseFloat(res.cartTotal).toFixed(2));
			}

			let details = {
				mods: data.message ? 'has-error' : '',
				isCart: true,
				count: res.cartCount,
				title: prop.title,
				total: '$' + parseFloat(res.cartTotal).toFixed(2),
				addedText: 'Added to your cart',
				link: prop.cartLink || '#',
				qty: data.quantityActual,
				itemImg: prop.prodImg,
				errorMsg: data.message,
				productCode: prop.code,
				recommendationsApi: utils.getRecommendationsApi($endpointDef.data('recommendations-endpoint') || ''),
				recommendationsTitle: res.recommendationsTitle || '',
				recommendationsViewMoreLink: res.recommendationsViewMoreLink || '',
				recommendationId: prop.recommendationId || '',
			};

			let dataShowRecsModal = $endpointDef.data('showrecsmodal');
			if ((window.innerWidth > utils.BREAKPOINT.LG) && (dataShowRecsModal === true  || dataShowRecsModal === 'true' || dataShowRecsModal === 'True')) {
				// close/remove all modal first
				$(`[data-wg="RecommendationsModal"]`).modal('hide');

				// add timeout to wait the modal hide first
				setTimeout(() => {
					showRecsModal(details);
				}, 500);
			} else {
				showNotification(details);
			}

			if (res.cartItems) {
				let cartItems = res.cartItems;
				if (typeof cartItems === 'string') {
					cartItems = JSON.parse(cartItems);
				}

				dataLayer.pushCartItems(cartItems);
			}

			if (succesCB) succesCB(data);
		} else {
			if (failCB) failCB(data);
		}
	});
}

export function giftCardAddToCart(prop, succesCB, failCB) {
	if (!prop.endpoint) {
		if (failCB) failCB({
			message: `Can't find Endpoint. Returned early.`
		});
		return;
	}

	let param = {
		'code': prop.code,
		'quantity': prop.quantity,
		'giftAmount': prop.giftAmount,
		'giftersName': prop.giftersName,
		'recipientName': prop.recipientName,
		'recipientEmail': prop.recipientEmail,
		'selectedDate': prop.selectedDate,
		'messageToRecipient': prop.messageToRecipient,
	};
	if (prop.customAmount !== '') param.customAmount = prop.customAmount;
	if (prop.settingAmount !== '') param.settingAmount = prop.settingAmount;

	let $endpointDef = $('.endpoints-definition');

	Api.callApi(prop.endpoint, param).then((data) => {
		if (data.result == 'SUCCESS') {
			// update cart count and total in the siteHeader
			let $cartCount = $(document).find('.siteHeader-cart .siteHeader-cartCount');

			let productObj = {
				code: prop.code,
				quantity: prop.quantity,
				giftAmount: prop.giftAmount,
				giftersName: prop.giftersName,
				recipientName: prop.recipientName,
				recipientEmail: prop.recipientEmail,
				selectedDate: prop.selectedDate,
				messageToRecipient: prop.messageToRecipient,
			};

			dataLayer.pushAddToCart(productObj, prop.datalayerDataSource);

			let res = data.response;

			if ($cartCount.length > 0) {
				$cartCount.text(res.cartCount);

				if (res.cartCount > 0) {
					$cartCount.removeClass(CLS_INVISIBLE);
				} else {
					$cartCount.addClass(CLS_INVISIBLE);
				}

				$(document).find('.siteHeader-subTotal').text(' = $' + parseFloat(res.cartTotal).toFixed(2));
			}

			let details = {
				mods: data.message ? 'has-error' : '',
				isCart: true,
				count: res.cartCount,
				title: prop.title,
				total: '$' + parseFloat(res.cartTotal).toFixed(2),
				addedText: 'Added to your cart',
				link: prop.cartLink || '#',
				qty: data.quantityActual,
				itemImg: prop.prodImg,
				errorMsg: data.message,
				productCode: prop.code,
				recommendationsApi: utils.getRecommendationsApi($endpointDef.data('recommendations-endpoint') || ''),
				recommendationsTitle: res.recommendationsTitle || '',
				recommendationsViewMoreLink: res.recommendationsViewMoreLink || '',
				recommendationId: prop.recommendationId || '',
			};

			let dataShowRecsModal = $endpointDef.data('showrecsmodal');
			if ((window.innerWidth > utils.BREAKPOINT.LG) && (dataShowRecsModal === true  || dataShowRecsModal === 'true' || dataShowRecsModal === 'True')) {
				// close/remove all modal first
				$(`[data-wg="RecommendationsModal"]`).modal('hide');

				// add timeout to wait the modal hide first
				setTimeout(() => {
					showRecsModal(details);
				}, 500);
			} else {
				showNotification(details);
			}

			if (res.cartItems) {
				let cartItems = res.cartItems;
				if (typeof cartItems === 'string') {
					cartItems = JSON.parse(cartItems);
				}

				dataLayer.pushCartItems(cartItems);
			}

			if (succesCB) succesCB(data);
		} else {
			if (failCB) failCB(data);
		}
	});
}

export function showNotification(data) {
	// register the template
	let partial = require('../../views/widgets/notifications/tmpl/notifications.hbs');
	Handlebars.registerPartial('notifications', partial);
	let theTemplateScript = `
		{{> notifications wg="notifications" ns="Notifications" }}
	`;
	let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
	let theTemplate = Handlebars.template(precompiled);
	let theCompiledHtml = theTemplate(data);
	$(document).find('body').append(theCompiledHtml);

	// Re-init script for notifications widget
	loadNotifications(document.body, false, true).then((wg) => {
		let hasRecommendations = !!data.recommendationsApi;
		if (wg) {
			wg.$el.data('recommendation-id', data.recommendationId);
			wg.init(hasRecommendations);
		}
	}).catch((error) => `${error} An error occurred while loading notifications script`);
}

function showRecsModal(data) {
	// register the template
	let partial = require('../../views/widgets/recommendationsModal/tmpl/recommendationsModal.hbs');
	Handlebars.registerPartial('recommendationsModal', partial);
	let theTemplateScript = `
		{{> recommendationsModal wg="recommendationsModal" ns="RecommendationsModal" }}
	`;
	let precompiled = new Function('return ' + Handlebars.precompile(theTemplateScript))();
	let theTemplate = Handlebars.template(precompiled);
	let theCompiledHtml = theTemplate(data);
	$(document).find('body').append(theCompiledHtml);

	// Re-init script for notifications widget
	loadRecommendationsModal(document.body, false, true).then((wg) => {
		if (wg) {
			wg.$el.data('recommendation-id', data.recommendationId);
			wg.init();
		}
	}).catch((error) => `${error} An error occurred while loading notifications script`);
}

export function handleTimeOutRequest(getPlacePrediction, callBackSuccess, callBackTimeOut) {
    const TIMEOUT_STATUS 	= 'REQUEST_TIMEOUT';
    const UNIT_MILLISECOND 	= 1000;
    const DEFAULT_SECOND 	= 10;
	const time = Number.parseFloat(window.timeToShowIsCnCStoreDropdown || 0);

	const getTime = () => {
		if (time <= 0) {
			return DEFAULT_SECOND * UNIT_MILLISECOND;
		}

		return time * UNIT_MILLISECOND;
	};

    const optionList = [
        new Promise(getPlacePrediction),
        new Promise(resolve => {
            setTimeout(resolve, getTime(), {
                status: TIMEOUT_STATUS
            });
        })
    ];

    Promise
        .race(optionList)
        .then(({ predictions, status }) => {
            if (status === TIMEOUT_STATUS) {
                callBackTimeOut();
            } else {
                callBackSuccess(predictions, status);
            }
        })
		.catch(() => {
			callBackTimeOut();
		});

}

export function handleDonate({$page, url, payload, callback}) {
	$('.loading-spinner').addClass('is-active');
	Api.callApi(url, payload || {}).then(function(response) {
		updateSummaryByDonate($page, response);
		$('.loading-spinner').removeClass('is-active');
		callback && callback();
	}).catch(function() {
		$('.loading-spinner').removeClass('is-active');
		callback && callback();
	});

	const getPrice = (price) => '$'+ parseFloat(price).toFixed(2);
	const updateSummaryByDonate = ($page, response) => {
		const {
			amount,
			total,
			totalWithoutShipping,
		} = response;
		$page.find('.donate-value-text').text(getPrice(amount));
		if (amount > 0) {
			$page.find('.js-donate').removeClass('d-none');
		} else {
			$page.find('.js-donate').addClass('d-none');

			// only action in checkout page.
			$page.find('.donate-radio').prop('checked', false);
			$page.find('.is-donate').removeClass('is-donate');
		}
		$page.find('.total-value').text(getPrice(total));
		$page.find('.total-without-shipping').text(getPrice(totalWithoutShipping));
	};
}

export function handleRemoveCoupon(el, api = $('[data-delete-coupon-endpoint]').attr('data-delete-coupon-endpoint') || '/api/cart/delete-promo/') {
	$(el).on('click', `.delete-coupon-btn`, function(e) {
		e.preventDefault();
		const discountCode = $(this).attr('discount-code');
		applyPromoCode($(el), {
			api,
			value: discountCode,
		});
	});
}

export function updatePriceItem({lineItemPrices}) {
	const itemElement = (id) => $(`.shoppingCartItem[data-id="${id}"], .miniCart-item[data-item-id="${id}"], .cart-list .cart-item[data-id="${id}"]`);
	(lineItemPrices || []).forEach(({extendedPrice, unitPrice, id, unitPriceInfos}) => {
		const $item = itemElement(id);
		$item.find('.itemSubTotal, .item-subtotal').text(getPriceOrFree(extendedPrice));
		const $cartTotal = $item.find('.shoppingCartItem-total');
		const $itemPrice = $item.find('.shoppingCartItem-itemPrice .price, .cart-item-price');
		if (unitPriceInfos) {
			if (unitPriceInfos.length === 1) {
				$itemPrice.html(`${
						unitPriceInfos[0].IsFree
						?
						`<span class="highlight">FREE</span>`
						:
						`<span class="strikethrough">$${unitPriceInfos[0].current}</span><span>$${unitPriceInfos[0].new}</span>`
					}`);
			} else if (unitPriceInfos.length > 1) {
				let pricesList = '';
				unitPriceInfos.forEach((item) => {
					let li = `<li><span class="sub-quantity">${item.quantity} x </span>
								${
									item.IsFree
									?
									`<span class="highlight">FREE</span>`
									:
									(item.new === '' ? `<span>${item.current}</span>` : `<span class="strikethrough">$${item.current}</span><span>$${item.new}</span>`)
								}
							  </li>`;
					pricesList = pricesList + li;
				});
				$itemPrice.html(`<ul>${pricesList}</ul>`);
			}
			if ($cartTotal) {
				$cartTotal.hasClass('highlight') ? '' : $cartTotal.addClass('highlight');
			}
		} else {
			$itemPrice.html(getPriceOrFree(unitPrice));
			if ($cartTotal) {
				$cartTotal.removeClass('highlight');
			}
		}
	});
}

export function refreshBonusBuyBadge(arrBonusBuy, itemsCart) {
	itemsCart.each((index, item) => {
		if (arrBonusBuy) {
			let bonusHtml = '';
			const bonusWrapper = $(item).find('.bonus-wrapper');
			const _item = arrBonusBuy[index];
			if (!_item) return;
			_item.bonusBuyBadges.forEach((bonus, i) => {
				let tempBonus = `<div class="bonus-buy-box">
									<div class="bonus-buy-info">
										<div class="bonus-buy-badge" style="color: ${bonus.textColor}; background-color: ${bonus.backgroundColor};">${bonus.name}</div>
										<div class="badge-desc">
											${bonus.description} - <a href="${bonus.browseUrl}" title="link">${bonus.browseText}</a>
										</div>
									</div>
								</div>`;
				let tempBonusScore = `<div class="bonus-buy-box" style="background-color: ${bonus.scoreBoxBackgroundColor}">
										<div class="bonus-buy-info">
											<div class="bonus-buy-badge" style="color: ${bonus.scoreTextColor}; background-color: ${bonus.scoreBackgroundColor};">${bonus.name}</div>
											<div class="badge-desc" style="color: ${bonus.scoreTextColor}">${bonus.scoreMessage}</div>
										</div>
									</div>`;
				bonusHtml = bonusHtml + (bonus.isScore ? tempBonusScore : tempBonus);
			});
			bonusWrapper.html(bonusHtml);
		}
	});
}

export function updateBonusBadgeOrderSummary(arrBonusBuy, itemsCart) {
	itemsCart.each((index, item) => {
		if (arrBonusBuy) {
			let bonusHtml = '';
			const bonusWrapper = $(item).find('.bonus-wrapper');
			arrBonusBuy[index].bonusBuyBadges.forEach((bonus, i) => {
				let tempBonus = `<div class="bonus-buy-badge"
									  style="color: ${bonus.isScore ? bonus.scoreTextColor : bonus.textColor};
									  		 background-color: ${bonus.isScore ? bonus.scoreBackgroundColor : bonus.backgroundColor};">
									${bonus.name}
								</div>`;
				bonusHtml = bonusHtml + tempBonus;
			});
			bonusWrapper.html(bonusHtml);
		}
	});
}

export function splitEmailEgiftCard(el, numberCharacterInline, numberCharacterInlineMobile) {
	let newFormatEmail = '';
	// const $el = $(el);
	const string = el.text();
	const splitE = string.split('@');
	const beforeE = splitE[0];
	const afterE = splitE[1];
	if (!el.hasClass('formatted')) {
		if ((string.length > numberCharacterInline && window.innerWidth > 768) ||
		(string.length > numberCharacterInlineMobile && window.innerWidth <= 425)) {
			newFormatEmail = `${beforeE}<br/>@${afterE}`;
			el.html(newFormatEmail);
		}
		el.addClass('formatted');
	}
}



// WEBPACK FOOTER //
// ./cart.js